import React from "react";
import styled from "styled-components";

type FormProps = {
  [key: string]: any;
};

type FormState = {
  [key: string]: any;
};

export default <P extends FormProps>(
  WrappedComponent: React.ComponentType<P & FormProps>
) => {
  return class extends React.PureComponent<P & FormProps, FormState> {
    public constructor(props: P & FormProps) {
      super(props);
    }

    public render(): JSX.Element {
      return (
        <Form>
          <WrappedComponent {...this.props} />
        </Form>
      );
    }
  };
};

const Form = styled.form`
  position: relative;
`;

export const FormGroup = styled.div<any>`
  display: flex;
  flex-direction: row;
  justify-content: left;
  margin-bottom: ${(props: any) =>
    props.fieldType === "radio" ? 0 : props.theme.spacing.desktop.s200}px;
  label {
    margin-right: ${(props: any) => props.theme.spacing.desktop.s500}px;
    &:last-child {
      margin-right: 0;
    }
  }
  @media ${(props: any) => props.theme.breakpoints.mobile} {
    ${(props: any) =>
      props.fieldType === "radio"
        ? `flex-direction: row;`
        : `flex-direction: column;
                    label {
                        margin-right: 0;
                    }`}
  }
`;

export const FormStatic = styled.div`
  flex: none;
  font-size: ${(props: any) => props.theme.typography.h200};
  line-height: ${(props: any) => props.theme.typography.h700};
  width: 100%;
  a {
    font-weight: 600;
  }
`;
